<template>
  <section class="release-section">
    <h2 class="release-title">
      {{ Release.title[lang] }}
    </h2>
  </section>
</template>

<script>
import Release from "../../../assets/constants/confirmation/cooperation/release/release";
export default {
  data() {
    return {
      Release: Release,
    };
  },
  props: {
    lang: {
      type: String,
    },
  },
  name: "Release",
};
</script>

<style scoped>
.release-section {
  margin: 60px 0 0 0;
  .release-title {
    font-size: 32px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/oauth/Release.vue